import I18n from 'i18n.js.erb';
import React, { useState } from "react";

const ImagePicker = ({
  type,
  id,
  setImage
}) => {

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    document.getElementById(`upload_${type}_image_${id}`).files = e.dataTransfer.files
    handleChangeImage(e)
  }


  // Funzione che si occupa dell'aggiornamento dell'immage mediante richiesta http al server
  const handleChangeImage = (e) => {
    let file;
    if (e.target && e.target.files)
      file = e.target.files[0]
    else
      file = e.dataTransfer.files[0]

    if (file) {
      setImage(file)
    }
  }

  return (
    <div className="dotted-border p-2 w-100"
         onDragOver={onDragOver}
         onDrop={e => onDrop(e)}>
      <div className="form-group">
        <p><b>{I18n.t('js.advancedSearch.uploadImage')}</b> <span className="color-dark-orange">{I18n.t('js.editSubmissionListPage.max5mb')}</span></p>
        <input
          accept="image/jpeg,image/gif,image/png"
          type="file"
          id={`upload_${type}_image_${id}`}
          name={`upload_${type}_image_${id}`}
          onChange={(e) => handleChangeImage(e)} />
      </div>
    </div>
  );
};

export default ImagePicker;
